import { FC } from 'react';

import { ToucanColors, ToucanComponents } from '@jointoucan/toucan-design';
import { useTranslation } from 'next-i18next';

import { Box } from '~/components/shared/Box';

const { Typography, Button } = ToucanComponents;

interface VerificationConfirmationProps {
  onConfirm: () => void;
  email: string;
  name?: string;
}

export const VerificationConfirmation: FC<VerificationConfirmationProps> = ({ email, onConfirm, name }) => {
  const { t } = useTranslation('dashboard');
  return (
    <Box>
      <Box mb={1}>
        <Typography font="secondary" variant="md">
          {t('verifyYourInformation')}
        </Typography>
      </Box>
      <Typography variant="sm">{t('toKeepYourAccountSecure')}</Typography>
      <Box my={2} border={`1px solid ${ToucanColors.gray[200]}`} p={2} borderRadius="4px">
        <Box mb={1} display="flex" alignItems="center">
          <Typography variant="sm" isBold>
            {t('sharedEmailField')}:
          </Typography>
          <Box ml={1}>
            <Typography variant="sm">{email}</Typography>
          </Box>
        </Box>
        {name && (
          <Box display="flex" alignItems="center">
            <Typography variant="sm" isBold>
              {t('sharedNameField')}:
            </Typography>
            <Box ml={1}>
              <Typography variant="sm">{name}</Typography>
            </Box>
          </Box>
        )}
      </Box>
      <Button type="utility" onClick={onConfirm}>
        {t('confirm')}
      </Button>
    </Box>
  );
};
